import type { App, Plugin } from 'vue'
import { version } from './version'

// 处理创建多个 app 实例 
const makeInstaller = (components: Plugin[] = []) => {
    const apps: App[] = []

    const install = (app: App) => {
        if (apps.includes(app)) return 

        apps.push(app)

        components.forEach(c => app.use(c))
    }

    return { version, install }
}

export default makeInstaller
